export const showLoader = state => state.commonReducer.showLoader;
export const editModeSelector = state => state.commonReducer.editMode;
export const user = state => state.commonReducer.user;
export const devices = state => state.commonReducer.devices;
export const globalLoading = state => state.commonReducer.globalLoading;
